import apiClient from './axios';
import { useDummyDataConfig } from '../config/dummyDataConfig';
import {
  userProfileDummyData,
  updateUserProfileDummyData,
  updateNotificationSettingsDummyData
} from '../data/userProfileDummyData';

/**
 * 유저 프로필 정보 조회
 * @returns {Promise} API 응답
 */
export const getUserProfile = async () => {
  // 더미 데이터 사용 여부 확인
  if (useDummyDataConfig.userProfile) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(userProfileDummyData);
      }, 300); // API 호출 시뮬레이션
    });
  }

  // 실제 API 호출
  const response = await apiClient.get('/api/user/profile');
  return response.data;
};

/**
 * 유저 프로필 정보 업데이트
 * @param {Object} profileData - 업데이트할 프로필 데이터
 * @param {string} profileData.nickname - 닉네임
 * @param {string} profileData.phone - 전화번호
 * @returns {Promise} API 응답
 */
export const updateUserProfile = async (profileData) => {
  // 더미 데이터 사용 여부 확인
  if (useDummyDataConfig.updateUserProfile) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          ...updateUserProfileDummyData,
          data: {
            ...updateUserProfileDummyData.data,
            ...profileData
          }
        });
      }, 500);
    });
  }

  // 실제 API 호출
  const response = await apiClient.patch('/api/user/profile', profileData);
  return response.data;
};

/**
 * 본인 비밀번호 바꾸기
 *
 * 지금 비밀번호를 함께 보낸다 — 서버가 그것을 확인한 뒤에만 바꾼다.
 * 남의 자리에 열려 있는 화면으로 비밀번호를 갈아 계정을 가져가는 것을 막기 위해서다.
 *
 * @param {string} currentPassword - 지금 쓰는 비밀번호
 * @param {string} newPassword - 새 비밀번호 (6자 이상)
 * @returns {Promise} API 응답
 */
export const changePassword = async (currentPassword, newPassword) => {
  const response = await apiClient.patch('/api/user/password', { currentPassword, newPassword });
  return response.data;
};

/* 로그인 이메일(가입 아이디)을 바꾸는 함수는 두지 않는다(2026-08-13 대표님 결정).
   이메일은 본인을 가리키는 값이라, 잘못 적었다면 고치는 것이 아니라 애초에 저장되지
   않아야 한다 — 막는 일은 가입 화면이 한다. */

/**
 * 알림 설정 업데이트
 * @param {Object} notificationSettings - 알림 설정
 * @param {boolean} notificationSettings.email - 이메일 알림
 * @param {boolean} notificationSettings.kakao - 카카오 알림
 * @returns {Promise} API 응답
 */
export const updateNotificationSettings = async (notificationSettings) => {
  // 더미 데이터 사용 여부 확인
  if (useDummyDataConfig.updateNotificationSettings) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          ...updateNotificationSettingsDummyData,
          data: notificationSettings
        });
      }, 500);
    });
  }

  // 실제 API 호출
  const response = await apiClient.patch('/api/user/notification-settings', notificationSettings);
  return response.data;
};
